var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"voice-command-display-wrapper",attrs:{"xs12":""}},[_c('div',{staticClass:"text"},_vm._l((_vm.getCommandQueue),function(comment,index){return _c('h3',{key:`${comment}${index}`},[_vm._v(" "+_vm._s(comment)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }